import axios from 'axios';

// Configuración base para Axios
const Apibig = axios.create({
  baseURL: 'https://siniestrosapi-552789706120.us-central1.run.app', // Cambia por la URL de tu API
  headers: {
    'Content-Type': 'application/json',
  },
});
export default Apibig